<template>
  <v-container>
    <h1>Update Empty Translations</h1>

    <v-tabs v-model="tab" grow>
      <v-tab
          v-for="progressName in progressList"
          :key="progressName">
        {{ progressName ? progressName : 'Main' }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
          v-for="progressName in progressList"
          :key="progressName">
        <progress-component
            script="UpdateEmptyTranslations"
            :progress-name="progressName"
            :run-available="!progressName"
            :delete-available="!progressName"
        >
        </progress-component>
      </v-tab-item>
    </v-tabs-items>

  </v-container>
</template>

<script>

import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'UpdateEmptyTranslations',
  components: { ProgressComponent },
  data: () => ({
    languages: [],
    progressList: [],
    tab: '',
  }),

  created() {
    this.$requestHelpers
      .get('api/admin/languages-list')
      .then((response) => {
        this.languages = response.data;
        this.languages.map((language) => {
          // eslint-disable-next-line no-param-reassign
          language.name = `${language.code} (${language.name})`;
          return language;
        });
      });

    this.$requestHelpers
      .post('api/admin/progress/getList', { script: 'UpdateEmptyTranslations' })
      .then((response) => {
        this.progressList = ['', ...response.data];
      });
  },
};
</script>
